
document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('[data-mobile-menu-button]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (button && drawer) {
    button.addEventListener('click', function () {
      const open = drawer.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});
